import axios from 'axios';
import { BaseURL } from '../constants';

/** @param {string} route */
export const fetchDataFromURL = async (route) => {
  const url = `${BaseURL}${route}`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    // Handle error response here
    if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 600
    ) {
      return Promise.reject(error.response.data);
    }
    return await Promise.reject('An error occurred while fetching data.');
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchDataFromURL.js